const API_NAMESPACE = 'manual';
const RECENT_CONFIGS_KEY = 'recent_configs';
const SAVED_CONFIGS_KEY = 'saved_configs';

export default {
  API_NAMESPACE,
  RECENT_CONFIGS_KEY,
  SAVED_CONFIGS_KEY,
};
